import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IFindNumberOfSheetsEnabledForAccelerationResult } from './FindNumberOfSheetsEnabledForAccelerationRequest';

export interface IFindAcceleratedViewLimitInfoParams {
}

export interface IFindAcceleratedViewLimitInfoResult extends IFindNumberOfSheetsEnabledForAccelerationResult {
  viewsLimitPerSiteForAcceleration: number;
  viewsLimitPerSiteForAccelerationEnabled: boolean;
}

export class FindAcceleratedViewLimitInfo extends
    Request<IFindAcceleratedViewLimitInfoParams, IFindAcceleratedViewLimitInfoResult> {
  constructor() {
    super('findAcceleratedViewLimitInfo', {});
  }
}
